import { getAll} from "../../fetchs/get";
import { sessionEnd } from "../../redux/actions";

export default async function getInvestsData (
    forecastId : string | undefined,
    forecastVersion: number | undefined,
    agency: string | null,
    setFeesData : Function,
    token : string | undefined,
    dispatch : Function,
    setError : Function
) {

    if(token){
        getAll(token, '/forecast/'+forecastId+"/"+forecastVersion+'/invests/'+agency, setFeesData, 
            () => {
                dispatch(sessionEnd());
            }, setError
        )
    }
}